import React, { useEffect, useState } from "react";
import Switch from "../../../../../../../components/Inputs/Switch/Switch";
import styles from '../styles.module.scss';
import { FormControlLabel, Radio, RadioGroup, withStyles } from "@material-ui/core";
import Button from "../../../../../../../components/Buttons/Button";
import FlexRow from "../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../components/SButton/SButton";
import FlexColumn from "../../../../../../../components/FlexBox/FlexColumn";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const BasicDetails = ({ hNext, hClose, accessPointDetails, updatedBasicDetails, inProgress = false }) => {
    const [withController, setWithController] = useState(false);
    const [controllerType, setControllerType] = useState('1');

    useEffect(() => {
        if (accessPointDetails?.withController) {
            setWithController(accessPointDetails?.withController)
        }
        if (accessPointDetails?.controllerType) {
            setControllerType(accessPointDetails?.controllerType)
        }
    }, [accessPointDetails]);

    useEffect(() => {
        updatedBasicDetails && updatedBasicDetails(withController, controllerType)
    }, [withController, controllerType])

    const handleChange = (event) => {
        setControllerType(event.target.value);
    };

    const handleNext = () => {
        const toSend = {
            withController,
            controllerType
        }
        const resetData = (withController !== accessPointDetails?.withController) || (withController ? controllerType !== accessPointDetails?.controllerType : false)
        hNext && hNext(toSend, 1, resetData);
    }


    return (<>
        <FlexColumn alignItems="start" gap="0" styles={{ marginBottom: '3rem' }}>
            <div className={styles['row']}>
                <div className={styles['column']}>
                    <h2 className={styles['bold-text']}>Use with controller</h2>
                    <p className={styles['note']}>Enable to create an access point connected to a controller</p>
                </div>
                <Switch
                    checked={withController}
                    onChange={() => {
                        if (!withController) {
                            setControllerType('1')
                        }
                        setWithController(!withController)
                    }}
                />
            </div>

            <div className={styles['divider']} />

            {withController && <div className={styles['column']}>
                <h2 className={styles['bold-text']} style={{ fontWeight: '500' }}>Controller type</h2>
                <RadioGroup aria-label="Controller-Type" name="controllerType" value={controllerType} onChange={handleChange}>
                    <FormControlLabel value="1" control={<StyledRadio />} label="Spintly" />
                    <FormControlLabel value="2" control={<StyledRadio />} label="Azure" />
                    <FormControlLabel value="5" control={<StyledRadio />} label="iStar" />
                    {/* DO NOT REMOVE REQUIRED IN NEXT PHASE 
                <FormControlLabel value="3" control={<StyledRadio />} label="ZKTeco" /> */}
                    <FormControlLabel value="4" control={<StyledRadio />} label="Others" />
                    {/* CONTROLLER TYPE = 6 IS FOR DCS CONTROLLER */}
                </RadioGroup>
            </div>}

        </FlexColumn>
        <FlexRow justifyContent="end" className={styles["fixed-actions"]}>
            <SButton disabled={inProgress} color={"grey"} minWidth onClick={() => { hClose && hClose() }}>Cancel</SButton>
            <SButton minWidth disabled={inProgress} onClick={handleNext}>Next</SButton>
        </FlexRow>

    </>)
};

export default BasicDetails;